import { REQUERT_MAIN_MENUAUTHORIZATION_FAILED, GET_DATA_MAIN_MENUAUTHORIZATION_SUCCEEDED
    ,GET_DATA_User_SUCCEEDED,REQUERT_User_FAILED
} from '../actions/actionTypes'
import {combineReducers} from 'redux'
const mainReducer = (DataMain = [], actions) => {
    switch (actions.type) {
        case GET_DATA_MAIN_MENUAUTHORIZATION_SUCCEEDED:
            if(Object.keys(actions.DataMain).length > 0)
            {
                return {...DataMain,DataMain: actions.DataMain};
            }
            else
            {
                return {...DataMain,DataMain: []};
            }
        case REQUERT_MAIN_MENUAUTHORIZATION_FAILED:
            return {...DataMain,DataMain: []};
        default:
            return DataMain;
    }
}
const GetuserReducer = (DataUser = [], actions) => {    
    switch (actions.type) { 
        case GET_DATA_User_SUCCEEDED:
            if (Object.keys(actions.DataUser).length > 0) {
                return { ...DataUser, DataUser: actions.DataUser };
            }
            else {
                return { ...DataUser, DataUser: [] };
            }
        case REQUERT_User_FAILED:
            return { ...DataUser, DataUser: [] };

        default:
            return DataUser;
    }
}

const mainALLReducer = combineReducers({
    mainReducer,GetuserReducer
})
export default mainALLReducer;